import * as React from 'react';

import cls from 'classnames';
import { activeItemToLinkProps } from './constants';
import Tooltip from 'rc-tooltip';
import { Link } from 'react-router-dom';
import { ActiveItem } from './types';

interface OwnProps {
    canNavigate?: (target: ActiveItem) => boolean;
    navigate?: (target: ActiveItem) => void;
    isCreateNewVenue?: boolean;
    currentVenueId?: number;
    activeItem?: ActiveItem;
}

const itemsConfig = [
    {
        type: ActiveItem.PREVIEW,
        label: 'PROFILE PREVIEW',
    },
    {
        type: ActiveItem.GENERAL,
        label: 'GENERAL INFORMATION',
    },
    {
        type: ActiveItem.AVAILABILITY,
        label: 'AVAILABILITY',
    },
    {
        type: ActiveItem.PRICING,
        label: 'PRICING',
    },
    {
        type: ActiveItem.AMENITIES,
        label: 'AMENITIES / RESTRICTIONS',
    },
];

export class Sidenav extends React.Component<OwnProps, {}> {
    constructor(props: OwnProps) {
        super(props);
        this.isActive = this.isActive.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
    }

    render() {
        return (
            <div className='VenueManagement--sidenav'>
                {itemsConfig.map(({ type, label }, idx) => {
                    const isActive = this.isActive(type);
                    const isDisabled = this.isDisabled(type);

                    if (type === ActiveItem.PRICING) {
                        return (
                            <div key={idx}>
                                <div className='VenueManagement--sidenav--item'>
                                    <a
                                        href={
                                            !!this.props.currentVenueId
                                                ? `/twsadmin/update/?v=${this.props.currentVenueId}`
                                                : '/twsadmin/update/'
                                        }
                                    >
                                        {label} <span className='icon-hb-nx-square-arrow' />
                                    </a>
                                </div>
                                <div className='VenueManagement--divider' />
                            </div>
                        );
                    }

                    return (
                        <div key={idx}>
                            <Tooltip
                                prefixCls='rc-tooltip__dark'
                                placement='top'
                                trigger={isDisabled ? ['hover'] : []}
                                mouseEnterDelay={0.3}
                                overlay={<span>This is not available until after the initial save.</span>}
                            >
                                <div
                                    className={cls({
                                        'VenueManagement--sidenav--item': true,
                                        'VenueManagement--sidenav--item__active': isActive,
                                        'VenueManagement--sidenav--item__disabled': isDisabled,
                                    })}
                                    onClick={() => {
                                        !isDisabled &&
                                            (!this.props.canNavigate ? true : this.props.canNavigate(type)) &&
                                            !!this.props.navigate &&
                                            this.props.navigate(type);
                                    }}
                                >
                                    {label}
                                </div>
                            </Tooltip>
                            <div className='VenueManagement--divider' />
                        </div>
                    );
                })}
            </div>
        );
    }

    private isActive(item: ActiveItem) {
        return this.props.activeItem === item;
    }

    private isDisabled(item: ActiveItem) {
        if (this.isActive(item)) {
            return false;
        }

        if (this.props.isCreateNewVenue && item !== ActiveItem.GENERAL) {
            return true;
        }

        if (item === ActiveItem.GENERAL || item === ActiveItem.AVAILABILITY || item === ActiveItem.AMENITIES) {
            return false;
        }

        return true;
    }
}
